var BootstrapDialog = require('bootstrap3-dialog');
var $ = require('jquery');

BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_DEFAULT] = '提示';
BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_INFO] = '提示';
BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_PRIMARY] = '提示';
BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_SUCCESS] = '成功';
BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_WARNING] = '警告';
BootstrapDialog.DEFAULT_TEXTS[BootstrapDialog.TYPE_DANGER] = '危险';
BootstrapDialog.DEFAULT_TEXTS['OK'] = '确定';
BootstrapDialog.DEFAULT_TEXTS['CANCEL'] = '取消';
BootstrapDialog.DEFAULT_TEXTS['CONFIRM'] = '确认';
BootstrapDialog.ICON_SPINNER = 'fa fa-asterisk';
BootstrapDialog.ALERT_DELAY_CLOSE = 1500;

BootstrapDialog.configDefaultOptions({
    type: BootstrapDialog.TYPE_DEFAULT,
    closeByBackdrop: false,
    closeByKeyboard: false
});
var alert = BootstrapDialog.alert;
BootstrapDialog.alert = function () {
    var alertOptions = {};
    var defaultAlertOptions = {
        type: BootstrapDialog.TYPE_DEFAULT,
        size: BootstrapDialog.SIZE_SMALL,
        title: null,
        message: null,
        closable: false,
        draggable: false,
        buttonLabel: BootstrapDialog.DEFAULT_TEXTS.OK,
        btnClass:'btn-danger',//自己新增
        autoClose:null,//自己新增,自动关闭:true|Number
        buttonHotkey: null,
        callback: null
    };

    if (typeof arguments[0] === 'object' && arguments[0].constructor === {}.constructor) {
        alertOptions = $.extend(true, defaultAlertOptions, arguments[0]);
    } else {
        alertOptions = $.extend(true, defaultAlertOptions, {
            message: arguments[0],
            callback: typeof arguments[1] !== 'undefined' ? arguments[1] : null
        });
    }
    var dialog =  alert(alertOptions);
    //处理btnClass
    if(dialog.options.btnClass != null && $.trim(dialog.options.btnClass) !== ''){
        dialog.getButtons()[0].cssClass = dialog.options.btnClass;
        dialog.updateButtons();
    }
    //
    if(dialog.options.autoClose){
        if($.type(dialog.options.autoClose)!=='number'||dialog.options.autoClose<=0){
            dialog.options.autoClose = BootstrapDialog.ALERT_DELAY_CLOSE;
        }
        clearTimeout(dialog.autoCloseTimeout);
        dialog.autoCloseTimeout = setTimeout(function () {
            if (typeof dialog.getData('callback') === 'function' && dialog.getData('callback')(false,true) === false) {
                return false;
            }
            dialog.setData('btnClicked', true);
            dialog.close();
        },dialog.options.autoClose);
    }


    return dialog;
};
var confirm = BootstrapDialog.confirm;
BootstrapDialog.confirm = function () {
    var confirmOptions = {};
    var defaultConfirmOptions = {
        type: BootstrapDialog.TYPE_DEFAULT,
        title: null,
        message: null,
        closable: false,
        draggable: false,
        btnCancelLabel: BootstrapDialog.DEFAULT_TEXTS.CANCEL,
        btnCancelClass: 'btn-info',
        btnCancelHotkey: null,
        btnOKLabel: BootstrapDialog.DEFAULT_TEXTS.OK,
        btnOKClass: 'btn-danger',
        btnOKHotkey: null,
        btnsOrder: BootstrapDialog.defaultOptions.btnsOrder,
        callback: null
    };
    if (typeof arguments[0] === 'object' && arguments[0].constructor === {}.constructor) {
        confirmOptions = $.extend(true, defaultConfirmOptions, arguments[0]);
    } else {
        confirmOptions = $.extend(true, defaultConfirmOptions, {
            message: arguments[0],
            callback: typeof arguments[1] !== 'undefined' ? arguments[1] : null
        });
    }
    return confirm(confirmOptions);
};

BootstrapDialog.prototype.updateMessage = function () {
    var self = this;
    if (this.isRealized()) {
        var message = this.createDynamicContent(this.getMessage());

        if(message && $.type(message.then)==='function'){
            Promise.resolve(message).then(function (message) {
                setMessage(message);
            },function () {
                setMessage('加载内容出错');
            })['finally'](function () {
                //TODO
            });
        }else{
            setMessage(message)
        }
    }
    function setMessage(message) {
        self.getModalBody().find('.' + self.getNamespace('message')).html('').append(message);
    }

    return this;
};

module.exports = BootstrapDialog;


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/bootstrap-dialog.js
// module id = 77
// module chunks = 0